import { useNavigate } from "react-router-dom"
import { ModalId, showToast, useUIActions } from "../../../../features/ui"
import { useStockService } from "../../services/stockService"

export const useActions = () => {
    const navigate = useNavigate()

    const { increaseStock, decreaseStock } = useStockService()

    const { openModal, closeModal } = useUIActions()

    const updateStock = async (
        productId: string,
        quantity: number,
        branchId: string,
        lotId: string,
        addMode = true
    ) => {
        openModal(ModalId.SPINNER)

        const updateStockFn = addMode ? increaseStock : decreaseStock
        await updateStockFn(productId, branchId, quantity, lotId)
        
        setTimeout(() => closeModal(ModalId.SPINNER), 500)
        showToast('El stock fue actualizado.')
        navigate(-1)
    }
    
    return {
        updateStock
    }
}
